import { render, staticRenderFns } from "./Importer.vue?vue&type=template&id=233ef6aa&scoped=true"
import script from "./Importer.vue?vue&type=script&lang=js"
export * from "./Importer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "233ef6aa",
  null
  
)

export default component.exports